import { uiTheme } from '@framework/ui/theme/uiTheme.tsx';
import { uiThemeComponentTokens } from '@framework/ui/theme/uiThemeComponentTokens.tsx';
import { uiThemeTokens } from '@framework/ui/theme/uiThemeTokens.tsx';
import { type OverrideToken } from 'antd/es/theme/interface';
import { type AliasToken } from 'antd/es/theme/internal';
import { merge } from 'lodash';

// TODO Gestire meglio `engine`
export const theme = {
  ...uiTheme,
  contentMaxWidth: 1248,
  submissionStateTagPositionAfter: true,
  tableScrollRequiresColumnFlag: true,

  darkAdminHeaderFlag: true,
  searchButtonOnTableFlag: true, // indica se visualizzare il pulsante di ricerca nella header

  overrideLayoutHeaderHeightFlag: true,
  // permette di gestire per header e footer se il contenuto e a tutta pagina o con un massimo di larghezza
  boxedFrontofficeHeaderFooterLayoutFlag: false,
  tablePageFullWidthFlag: true,

  forceRemoveFooterOnLoadingPage: true,
  showHeaderFooterOnLoginPage: true,

  // Button come impostato nel Token
  tokenButtonLineWidth: 2,

  // Underline BreadCrumb
  breadcrumbTextDecoration: 'underline',

  // Header
  layoutHeaderHeight: 70, // 64 + 14 fascetta rossa
  layoutHeaderContentHeight: 64, // altezza interna del contenuto del header
  layoutHeaderTopBgColor: '#0f2a48', // questo
  layoutHeaderTopColor: '#fff', // questo
  // Footer
  layoutFooterBgColor: '#16395e',
  layoutFooterColor: '#fff',
  layoutFooterLinkColor: '#fff', // '#65dcdf',
  layoutFooterLinkHoverColor: '#fff', //'#21a1a4',

  // Applicativi
  logoUrl: require('./images/logo-rer.svg'),
  logoAltText: 'Logo Regione Emilia-Romagna',
  logoFrontName: 'Domande',
  logoTextLine1: 'Framework',
  logoTextLine2: 'Procedimenti',
  spaceImageUrl: require('./images/space.png'),
  redRer: '#cb1d15',
  grayRer: '#1c2024',
  greenRer: '#008554',
  // neutralRer: '#eee',
  orangeButtonRer: '#FF9233',

  // RTE
  rteLinkColor: '#16395e',
  rteLinkHoverColor: '#122e4c',

  showIntegrationReadonlyWidgetsAsDisabled: true,
};

// È importante utilizzare `merge` perché tutti i token dell'ui
// sono _annidati_ (come li definisce Ant.Design), quindi per fare
// sovrascritture parziali dobbiamo usare merge e non un semplice
// spread
export const themeComponentTokens = merge(uiThemeComponentTokens, {
  Layout: {
    headerHeight: 82,
    bodyBg: '#f3f7fc',
    // headerBg: '#16395e',
    // headerColor: '#fff',
  },
  Alert: {
    colorSuccessBg: '#e7f7f1',
  },
  Button: {
    lineWidth: 2,
    // defaultBorderColor: '#30373d',
    // colorLink: '#30373D',
    // colorLinkActive: '#202529',
    // colorLinkHover: '#202529',
  },
  Menu: {
    motionDurationMid: '0.05',
    motionDurationSlow: '0.1',
    activeBarHeight: 0,
    linkDecoration: 'none',
    // horizontalLineHeight: '32px',
    // lineHeight: '32px',
  },
} satisfies Partial<OverrideToken>);

export const themeTokens = merge(uiThemeTokens, {
  fontFamily:
    "'Titillium Web', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
  // fontSize: 16,
  // linkHoverDecoration: 'underline',
  // linkDecoration: 'underline',
  borderRadius: 4,

  colorPrimary: '#16395e', // '#30373D', // '#1c2024',
  colorPrimaryHover: '#122e4c',
  colorPrimaryBg: '#dee2e4',
  // fix colore Menu selezionato se modificato Primary in #1c2024
  // colorBgTextHover: '#ecfaf5',
  // controlItemBgActive: '#f0f0f0', // '#c9f5dc',

  colorSuccess: '#008554',
  colorInfo: '#0b00d9',
  colorWarning: '#ff9700',
  colorError: '#cb1d15',

  colorLink: '#16395e', // '#30373D',
  // colorLinkActive: '#202529',
  // colorLinkHover: '#202529',

  // colorPrimaryHover: '#2E2EFF',
  // colorLinkHover: '#2E2EFF',
} satisfies Partial<AliasToken>);
